import { render, staticRenderFns } from "./ObjectCreation.vue?vue&type=template&id=79f4f4c4&"
import script from "./ObjectCreation.vue?vue&type=script&lang=js&"
export * from "./ObjectCreation.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCreation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports